// vue3-migration -- Element
import langTr from 'element-plus/es/locale/lang/tr';
import translations from './translations.json';
import 'moment/locale/tr';

export default {
  ...translations,
  // vue3-migration -- Element
  ...langTr,
};
